export default __webpack_public_path__ + "05e7de3d8c3bbb77c2196b25b9a93f80.png";